import { object, array, string } from '@gogame/schemas';

import {
  COLUMN_ID,
  COLUMN_NAME,
  COLUMN_CAMPAIGNS,
  COLUMN_COUNTRY,
  COLUMN_AFFILIATE,
  COLUMN_NETWORK,
  COLUMN_PLATFORM,
  COLUMN_APPLICATION,
  COLUMN_ACTIVITY_TYPE,
  COLUMN_HAS_REWARDS,
  COLUMN_HAS_COST_MODELS,
  COLUMN_FRAUD_PROTECTIONS,
  COLUMN_EXPIRATION_DATE,
  COLUMN_PROMO_CODE,
  COLUMN_UPDATED_DATE,
  COLUMN_CREATED_BY,
  COLUMN_CREATED_DATE,
} from 'scenes/Campaigns/constants';

export const columnsSchema = object({
  order: array(string()).default([
    COLUMN_ID,
    COLUMN_NAME,
    COLUMN_CAMPAIGNS,
    COLUMN_AFFILIATE,
    COLUMN_APPLICATION,
    COLUMN_NETWORK,
    COLUMN_PLATFORM,
    COLUMN_COUNTRY,
    COLUMN_ACTIVITY_TYPE,
    COLUMN_HAS_REWARDS,
    COLUMN_HAS_COST_MODELS,
    COLUMN_FRAUD_PROTECTIONS,
    COLUMN_EXPIRATION_DATE,
    COLUMN_PROMO_CODE,
    COLUMN_UPDATED_DATE,
    COLUMN_CREATED_BY,
    COLUMN_CREATED_DATE,
  ]),
  collapsed: array(string()).default([]),
});
